import type { Id } from '@e-socna/data-layer';

type CompatibleWorkflow = Readonly<{
  compatibilities: Readonly<{ missionWorkflowIds: readonly Id[] | null }>;
}>;

// A quotation, accounting, report or business event workflow without mission
// workflow restriction accepts every mission workflow, as the init pipes of
// the back do.
export const filterWorkflowsOfMissionWorkflow = <W extends CompatibleWorkflow>(
  workflows: readonly W[],
  missionWorkflowId: Id,
): readonly W[] =>
  workflows.filter(
    ({ compatibilities: { missionWorkflowIds } }) =>
      !missionWorkflowIds || missionWorkflowIds.includes(missionWorkflowId),
  );

// The default workflow when it accepts the mission workflow, otherwise the
// first one accepting it; the default stays the fallback so that the back
// reports the incompatibility.
export const findInitialWorkflowOfMissionWorkflow = <
  W extends CompatibleWorkflow & Readonly<{ _id: Id }>,
>(
  workflows: readonly W[],
  defaultWorkflow: W,
  missionWorkflowId: Id,
): W => {
  const compatibleWorkflows = filterWorkflowsOfMissionWorkflow(
    workflows,
    missionWorkflowId,
  );

  return (
    compatibleWorkflows.find(({ _id }) => _id === defaultWorkflow._id) ??
    compatibleWorkflows[0] ??
    defaultWorkflow
  );
};
